import {
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/library/accordion";
import { ChildContent } from "./components/ChildContent";
import { ChildTrigger } from "@/module/education/nicheSideRoutes/components/education-details/ChildTrigger";

export function ChildItem({ child, isOpen, isCurrentChild }: any) {
  const isActive = !child.isFroze;

  return (
    <AccordionItem
      key={child.id}
      value={String(child.id)}
      className={`border rounded-xl mb-2 px-3 py-2.5 last:border-b ${
        isCurrentChild
          ? "border-[#267355]/30 bg-[#f0faf5]"
          : isActive
            ? "border-[#e6e8e7] bg-white hover:border-[#d0d4d2]"
            : "border-[#e6e8e7] bg-[#fafafa]"
      } transition-colors`}
    >
      <AccordionTrigger className="hover:no-underline py-0">
        <ChildTrigger child={child} isOpen={isOpen} />
      </AccordionTrigger>

      <ChildContent child={child} />
    </AccordionItem>
  );
}
